/**
 * General messages on the WS Socket
 */
export enum ConstWsSocketMessagesEnum {
  DisconnectThroughMultipleDevices = 'DISCONNECT_THROUGH_MULTIPLE_DEVICES',
}
